// Two glyphs the landing footer needs that the shell icon set does not carry (plus / shield —
// prototype landingView's compose affordance). Same idiom as src/app/Icon.tsx: 24×24 viewBox, inline
// stroke, 1.7 weight, rounded joins, single tone in currentColor, decorative (aria-hidden) — authored
// here because the shell's Icon.tsx is not this surface's file to extend (G-181; no emoji, no font).

const GLYPH_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
} as const;

/** The compose affordance's plus glyph. */
export function PlusGlyph({ size = 14 }: { readonly size?: number }): React.JSX.Element {
  return (
    <svg {...GLYPH_PROPS} width={size} height={size}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

/** The operator-tag shield glyph. */
export function ShieldGlyph({ size = 11 }: { readonly size?: number }): React.JSX.Element {
  return (
    <svg {...GLYPH_PROPS} width={size} height={size}>
      <path d="M12 3.5l7 2.5v5c0 4.2-2.9 7.4-7 8.5-4.1-1.1-7-4.3-7-8.5V6z" />
    </svg>
  );
}
